export const BROADBAND_TYPE_ADSL = 'ADSL'
export const BROADBAND_TYPE_FIBRA = 'Fibra'
